module.exports = __webpack_public_path__ + "img/cwm-websitetiles-itwct-f01-memorialhall-72dpi.5c00f183.jpg";